import React from 'react';
import logo from '../images/LightFeather_Logo_2021.png';

const LogoIcon = () => (
  <img className='max-w-225-px sm:max-w-275-px justify-center' src={logo} alt='Logo' />
);

export default LogoIcon;
